import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ReportDataTableComponent } from '../report-data-table/report-data-table.component';

@Component({
    selector: 'app-dynamic-data-grid',
    templateUrl: '../report-data-table/report-data-table.component.html',
    styleUrls: ['../report-data-table/report-data-table.component.scss'],
    standalone: false
})
export class DynamicDataGridComponent extends ReportDataTableComponent {

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService
  ) {
    super(injector, router, route, modal)
  }

  getDataForCrudOperationFn(resouceDef) {
    if (resouceDef && resouceDef.list && resouceDef.list.dynamic_fields && resouceDef.list.dynamic_fields.datasource != undefined) {
      this.getResourceField(resouceDef.list.dynamic_fields.datasource, resouceDef.list.fields ? resouceDef.list.fields.length : 0, (res) => {
        if (resouceDef.list.fields && resouceDef.list.fields.length != 0)
          resouceDef.list.fields = [...res, ...resouceDef.list.fields]
        else
          resouceDef.list.fields = res;
        super.getDataForCrudOperationFn(resouceDef);
      })
    }
    else
      super.getDataForCrudOperationFn(resouceDef);
  }

  getResourceField(datasource: any, length, cb?) {
    let query_id = datasource.query_id == undefined ? "GET_PAGE" : datasource.query_id;
    let resource = datasource.resource == undefined ? "" : datasource.resource;
    let application = datasource.application == undefined ? "" : datasource.application;
    let filter = datasource.filter == undefined && datasource.filter == false ? "" : this._currentData.gridData.filter
    this.baseService.get(query_id, this.baseService.buildDyanamicStr(datasource.args), resource, application, filter).subscribe((res: any) => {
      if (res.errCode == -1) {
        cb(false)
      } else {
        res.resource.map((x, index) => {
          x['order'] = length + index + 1;
          x['card_tag'] = null;
          x['sortable'] = true;
          x['name'] = this._currentData.resouceDef.list.dynamic_key + "." + x.name
        })
        cb(res.resource);
      }
    })
  }

}
